/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {Article} from "types/entities/Article";
import {DateRange} from "types/entities/PackageItem";

export interface VoucherItem {
    id: number;
    guid: string;
    hall_id: number;
    article_id: number;
    vendor_name: string;
    campaign_name: string;
    code: string;
    update_sequence: number;
    amount_left: number;
    amount_total: number;
    max_persons_count: number | null;
    min_persons_count: number | null;
    validity: boolean;
    article: Article;
    extra: VoucherItemExtra;
    blocked_at: string | null;
    created_at: string | null;
    deleted_at: string | null;
    expires_at: string | null;
    updated_at: string | null;
}

export enum VoucherTypeFilter {
    Activity = "activity",
    Article = "article",
    All = "all",
}

export enum VoucherDiscountType {
    Access = "access",
    AccessExtra = "access_extra",
    Race = "race",
    Activity = "activity",
    Value = "value",
    Percent = "percent",
    Credit = "credit",
    General = "general",
}

export interface VoucherType {
    label: string;
    value: number;
    type: VoucherDiscountType;
    filterBy: VoucherTypeFilter[];
    valueFormatted: string;
}

export interface VoucherItemExtra {
    valid_on_date: string | null;
    excludeDateRange: DateRange[];
    includeDateRange: DateRange[];
    includeWeekDays: number[];
    excludeWeekDays: number[];
}
